import { Pipe, PipeTransform } from '@angular/core';
import { Params } from '@angular/router';
import {
  productDetailQueryParams,
  productDetailRouterLink
} from '../../core/utils/product-detail-route.util';
import { Product } from '../classes/product';

@Pipe({
  name: 'productDetailLink'
})
export class ProductDetailLinkPipe implements PipeTransform {
  transform(product: Product | null | undefined): string[] {
    return productDetailRouterLink(product);
  }
}

@Pipe({
  name: 'productDetailQueryParams'
})
export class ProductDetailQueryParamsPipe implements PipeTransform {
  transform(product: Product | null | undefined): Params {
    return productDetailQueryParams(product);
  }
}
